import { toPoints} from '@/shared/helpers'
export const TABLE_COLUMNS = [
  {
    Header: "Program Name",
    accessor: "program_name",
  },
  {
    Header: "Status",
    accessor: "status",
  },
  {
    Header: "Count",
    accessor: "count",
  },
  {
    Header: "Unique Count",
    accessor: "unique_count",
  },
];
